export default route => route.replace(/\.[^/.]+$/, "")
